module.exports = __webpack_public_path__ + "static/media/logo-small-green.58e06c52.svg";